import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import global from "./modules/global";
import user from "./modules/user";
import order from "./modules/order";
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: "orderForm"
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: undefined,
  mutations: {},
  actions: {},
  modules: {
    global,
    user,
    order
  },
  plugins: [vuexLocal.plugin]
});
